import { Outlet } from "react-router-dom";

import { FilterWaiverProvider } from "./filter-waiver/filter-waiver.context";
import './waiver.scss';

export function Waiver() {
  return (
    <div id="ShellWaiver" className="waiver">
       <FilterWaiverProvider>
        <Outlet />
      </FilterWaiverProvider>
    </div>
  );
}

export default Waiver;
